module.exports = __webpack_public_path__ + "img/353.a43cc484.png";